import type { LegalDoc } from '../types';

// Transcribed 1:1 from "01 - Terminos de Servicio v1.0.pdf" (MEC Vault/legal/app-legal).
export const terminos: LegalDoc = {
  slug: '/terminos',
  title: 'Términos y Condiciones de Servicio',
  version: '1.0',
  updated: 'Julio de 2026',
  entity: 'Mi Envío Cuba',
  seoDescription:
    'Términos y Condiciones de Servicio de Mi Envío Cuba: naturaleza de la plataforma, servicios facilitados, precios, Casillero, cancelaciones, privacidad y disputas.',
  closing: 'Fin de los Términos.',
  sections: [
    {
      id: 'seccion-1',
      number: '1',
      title: 'Aceptación',
      blocks: [
        {
          t: 'p',
          text: 'Al crear una cuenta o usar la aplicación “Mi Envío Cuba” (la “Aplicación”) o cualquier servicio de MEC LLC (“MEC”, “nosotros”), usted (“Usuario”, “usted”) acepta estos Términos y la Política de Privacidad. Si no está de acuerdo, no use la Aplicación.',
        },
        {
          t: 'p',
          text: 'Estos Términos contienen, entre otras cosas: (i) la naturaleza de MEC como **proveedor de software** (Sección 3); (ii) **declaraciones obligatorias bajo sanciones de los Estados Unidos**; (iii) una cláusula de **venta final sin reembolsos para Casillero Tienda**; (iv) una cláusula de **indemnización**; (v) una cláusula de **arbitraje obligatorio**; y (vi) una **renuncia a demandas colectivas**. Léalos.',
        },
      ],
    },
    {
      id: 'seccion-2',
      number: '2',
      title: 'Quién puede usar la Aplicación',
      blocks: [
        { t: 'p', text: 'Para usar la Aplicación usted declara que:' },
        {
          t: 'ul',
          items: [
            'Tiene al menos 18 años.',
            'Reside legalmente en los Estados Unidos.',
            'No es una persona sancionada por OFAC ni por ninguna otra autoridad de sanciones aplicable.',
            'La información que proporciona en su cuenta es veraz y la mantendrá actualizada.',
          ],
        },
        {
          t: 'p',
          text: 'MEC puede verificar su identidad en cualquier momento y usted acepta cooperar razonablemente con dichas verificaciones. Si no podemos verificarla o la verificación arroja un resultado que requiere revisión, podemos suspender o cancelar transacciones sin responsabilidad.',
        },
      ],
    },
    {
      id: 'seccion-3',
      number: '3',
      title: 'Naturaleza de la Plataforma — MEC como proveedor de software',
      blocks: [
        { t: 'h3', text: '3.1 MEC es una plataforma de software' },
        {
          t: 'p',
          text: 'Mi Envío Cuba es una **plataforma tecnológica** operada por MEC LLC que conecta al Usuario con **proveedores independientes de servicios** en el corredor Estados Unidos — Cuba. La Aplicación, sus interfaces, y el marketplace son productos de software.',
        },
        {
          t: 'p',
          text: '**MEC no es un transportista, un comerciante, un vendedor de bienes, un proveedor de entrega, ni un consolidador de carga.** MEC no toma custodia física de ningún bien, no envía paquetes, no vende productos, no entrega mercancía, y no consolida contenedores.',
        },
        { t: 'h3', text: '3.2 Sus contrapartes en cada servicio' },
        {
          t: 'p',
          text: 'Cuando usted utiliza la Aplicación, su contraparte contractual efectiva por el servicio subyacente es:',
        },
        {
          t: 'ul',
          items: [
            '**Envío de paquetes a Cuba:** la agencia de envíos estadounidense que usted seleccione (la “Agencia”), quien es responsable de recibir, consolidar, transportar y entregar el paquete al destinatario en Cuba.',
            '**Marketplace de productos cubanos:** el comerciante cubano (paladar, mercado, mipyme, TCP u otro comerciante privado) que usted seleccione (el “Comerciante”), quien es responsable de vender, preparar y entregar el producto al destinatario en Cuba.',
            '**Casillero Envíos:** el transportista externo que usted contrate para el tramo hasta la dirección receptora, y la Agencia una vez recibido el paquete.',
            '**Casillero Tienda:** la tienda externa (SHEIN, Amazon, Walmart u otra habilitada) donde usted es el comprador de derecho; MEC o la Agencia actúa únicamente como su mandatario para ejecutar la compra conforme a la Sección 9.',
          ],
        },
        {
          t: 'p',
          text: 'MEC no es parte de los contratos que usted celebra con las Agencias, los Comerciantes, los transportistas externos o las tiendas externas, salvo en el rol expreso de mandatario descrito en la Sección 9.2.',
        },
        { t: 'h3', text: '3.3 Lo que MEC provee' },
        {
          t: 'p',
          text: 'MEC provee, únicamente, los siguientes servicios de software y plataforma:',
        },
        {
          t: 'ol',
          items: [
            'La Aplicación móvil y las plataformas web asociadas (Mi Dashboard, Mi Admin, Mi Restaurante, Mi Cargo).',
            'La interfaz de mercado (marketplace) donde el Usuario encuentra Agencias y Comerciantes.',
            'La facilitación del pago a través de un procesador externo autorizado.',
            'El filtrado de partes restringidas (OFAC, Cuba Restricted List) al momento de la transacción.',
            'Las herramientas de comunicación, seguimiento, y auditoría entre las partes.',
            'El soporte al Usuario para asuntos de la plataforma (problemas técnicos, disputas de facturación de MEC, incidentes de seguridad).',
          ],
        },
        { t: 'h3', text: '3.4 Lo que MEC no provee y de lo que no es responsable' },
        {
          t: 'p',
          text: 'Sin perjuicio de las obligaciones expresas de MEC bajo estos Términos, MEC no:',
        },
        {
          t: 'ol',
          items: [
            'toma custodia física de bienes;',
            'transporta, consolida, despacha, ni entrega paquetes;',
            'prepara, vende, ni distribuye productos del marketplace;',
            'provee crédito, préstamo, ni servicios financieros más allá de la facilitación de pago descrita;',
            'garantiza la calidad, idoneidad, tiempo de entrega, ni disponibilidad de los servicios o productos provistos por las Agencias, los Comerciantes, los transportistas externos o las tiendas externas;',
            'es responsable por los actos u omisiones de las Agencias, los Comerciantes, los transportistas externos o las tiendas externas.',
          ],
        },
        {
          t: 'p',
          text: 'Cualquier disputa relacionada con la ejecución del servicio subyacente (por ejemplo, un paquete no entregado, un producto no conforme, un envío demorado) es principalmente una disputa entre usted y la Agencia, el Comerciante, o la tienda correspondiente. MEC facilitará razonablemente la comunicación, pondrá a disposición los registros de la plataforma, y podrá suspender el procesamiento del pago cuando sea apropiado, pero MEC no es la parte responsable del servicio subyacente.',
        },
      ],
    },
    {
      id: 'seccion-4',
      number: '4',
      title: 'Servicios que la Plataforma facilita',
      blocks: [
        {
          t: 'p',
          text: 'A través de la Aplicación, el Usuario puede acceder a los siguientes servicios provistos por terceros independientes:',
        },
        {
          t: 'ul',
          items: [
            'Envío de paquetes desde EE. UU. hacia Cuba operado por Agencias bajo las licencias generales aplicables de OFAC (31 C.F.R. § 515.572 y § 515.582) y, cuando aplique, la excepción de licencia general SCP del Departamento de Comercio (15 C.F.R. § 740.21).',
            'Marketplace de productos vendidos por Comerciantes cubanos para entrega al destinatario en Cuba.',
            'Casillero Envíos — pre-aviso de paquetes que el Usuario envía por su cuenta a la dirección receptora de la Agencia (ver Sección 9).',
            'Casillero Tienda — compra asistida en tiendas externas, ejecutada bajo autorización expresa del Usuario (ver Sección 9).',
          ],
        },
        {
          t: 'p',
          text: 'Los Servicios disponibles, sus modalidades, tarifas, tipos de cambio y plazos pueden variar y están sujetos a la legislación de los Estados Unidos (incluyendo sanciones OFAC y regulaciones EAR/BIS), la legislación cubana, condiciones operacionales, y decisiones comerciales razonables de MEC, las Agencias, los Comerciantes y los transportistas.',
        },
        {
          t: 'p',
          text: 'MEC podrá, en cualquier momento y sin responsabilidad, suspender, modificar o discontinuar funciones de la plataforma, y las Agencias y los Comerciantes podrán suspender, modificar o discontinuar sus propios servicios.',
        },
      ],
    },
    {
      id: 'seccion-5',
      number: '5',
      title: 'Declaraciones del Remitente (OFAC y BIS)',
      blocks: [
        {
          t: 'p',
          text: 'Cada vez que envíe un paquete, inicie un Casillero Envío, ejecute una compra asistida bajo Casillero Tienda, o realice un pedido en el Marketplace, usted declara a MEC, a la Agencia o al Comerciante correspondiente, **y por extensión al gobierno de los Estados Unidos**, que:',
        },
        {
          t: 'ol',
          items: [
            'Usted **no es una persona sancionada** ni actúa por cuenta de una.',
            'El destinatario en Cuba **no es una persona sancionada**, ni un funcionario prohibido del gobierno cubano (31 C.F.R. § 515.337), ni un miembro prohibido del Partido Comunista de Cuba (31 C.F.R. § 515.338).',
            'El contenido del paquete o del pedido es un **regalo o donación personal**, sin fines comerciales, sin reventa, sin contraprestación.',
            'Cuando los bienes estén sujetos a las Regulaciones de Exportación de EE. UU. (EAR), el envío se realiza bajo la excepción de licencia general “Support for the Cuban People” (SCP), 15 C.F.R. § 740.21, los bienes están autorizados, y no se entregarán a personas prohibidas ni se usarán para fines comerciales o en apoyo del gobierno cubano.',
            'El propósito del envío es legal y respeta todas las leyes aplicables.',
          ],
        },
        {
          t: 'p',
          text: 'Las declaraciones falsas pueden constituir delito federal en los Estados Unidos (18 U.S.C. § 1001 y 13 U.S.C. § 305). Si MEC, la Agencia o el Comerciante tienen motivos razonables para sospechar que cualquier declaración es falsa, cada uno de ellos podrá rechazar, retener o cancelar la transacción, reportar a las autoridades, y suspender o cancelar el acceso del Usuario, sin que ello genere responsabilidad frente al Usuario.',
        },
      ],
    },
    {
      id: 'seccion-6',
      number: '6',
      title: 'Información del Destinatario y Escenarios de Entrega',
      blocks: [
        { t: 'h3', text: '6.1 Información que usted proporciona' },
        {
          t: 'p',
          text: 'Al designar un destinatario, usted proporciona: nombre completo, carné de identidad (CI), dirección física en Cuba (provincia, municipio, dirección detallada) y teléfono. Esta información se transmite, a través de la Plataforma, a la Agencia o al Comerciante encargado del servicio, para la verificación, coordinación y ejecución de la entrega. Usted es responsable de la exactitud y legitimidad de esta información.',
        },
        { t: 'h3', text: '6.2 Cambios en el destinatario' },
        {
          t: 'p',
          text: 'Una vez iniciada una transacción, los cambios en la información del destinatario pueden estar limitados o no disponibles, a discreción de la Agencia o el Comerciante y sujetos a restricciones operacionales, aduanales, o regulatorias. MEC podrá facilitar la solicitud de cambio a través de la Plataforma, pero la aprobación depende del prestador del servicio.',
        },
        { t: 'h3', text: '6.3 Destinatario inubicable, ausente, o que rechaza' },
        {
          t: 'p',
          text: 'Si el paquete o el pedido no puede entregarse al destinatario por causas no atribuibles a la Agencia, al Comerciante ni a MEC — incluyendo dirección incorrecta, destinatario inubicable, destinatario ausente tras intentos razonables, destinatario que rechaza recibir, fallecimiento del destinatario, o restricciones impuestas por autoridades cubanas — la Agencia o el Comerciante podrá, según su política publicada: (a) intentar entrega alternativa a un familiar o dirección alternativa razonable; (b) retornar el paquete o los fondos al Usuario, deduciendo tarifas no reembolsables conforme a la Sección 10; o (c) coordinar con el Usuario una acción distinta.',
        },
        { t: 'h3', text: '6.4 Datos privados del destinatario' },
        {
          t: 'p',
          text: 'El destinatario no es parte de estos Términos, pero su información personal es tratada por MEC con el mismo nivel de protección que la del Usuario, conforme a la Política de Privacidad.',
        },
      ],
    },
    {
      id: 'seccion-7',
      number: '7',
      title: 'Cómo debe usar la Aplicación',
      blocks: [
        { t: 'p', text: 'Usted se compromete a no:' },
        {
          t: 'ul',
          items: [
            'Usar la Aplicación para fines ilegales (lavado de dinero, evasión de sanciones, fraude, evasión fiscal).',
            'Enviar u ordenar **artículos prohibidos** conforme a la Sección 6, a la Política de Artículos Prohibidos, y a la ley aplicable. Esta prohibición aplica a paquetes tradicionales, pedidos del Marketplace, Casillero Envíos y Casillero Tienda.',
            'Designar destinatarios prohibidos (Sección 5).',
            'Eludir mecanismos de seguridad, autenticación, verificación de identidad, filtrado OFAC, o controles de límite que la Plataforma implemente.',
            'Realizar ingeniería inversa de la Aplicación, ni utilizarla para construir un servicio competidor.',
            'Utilizar bots, scrapers, u otros medios automatizados para acceder a la Aplicación sin autorización expresa de MEC.',
            'Introducir en la Aplicación virus, software malicioso, o cualquier código diseñado para interferir con su funcionamiento o acceder sin autorización a sistemas de MEC, las Agencias, los Comerciantes u otros Usuarios.',
            'Suplantar la identidad de otro Usuario, de una Agencia, de un Comerciante, o de MEC.',
          ],
        },
        {
          t: 'p',
          text: 'Usted acepta cooperar razonablemente con verificaciones de identidad, verificaciones contra listas de sanciones, solicitudes de atestación adicional, y solicitudes razonables de información que MEC, la Agencia, el Comerciante o una autoridad competente puedan requerir para el cumplimiento de la ley aplicable.',
        },
        {
          t: 'p',
          text: 'MEC y los socios operativos pueden inspeccionar paquetes y rechazar, retener o entregar a las autoridades cualquier artículo prohibido. Usted puede ser responsable de las consecuencias legales y los costos.',
        },
      ],
    },
    {
      id: 'seccion-8',
      number: '8',
      title: 'Precios, tarifas, tipos de cambio y pagos',
      blocks: [
        { t: 'h3', text: '8.1 Composición del precio total' },
        {
          t: 'p',
          text: 'Los precios totales se muestran **antes de la confirmación** de la transacción. Su confirmación es aceptación del precio. El precio total puede incluir, según el servicio:',
        },
        {
          t: 'ol',
          items: [
            'el costo del producto o del flete cobrado por el Comerciante o la Agencia;',
            'el arancel aduanal cubano, estimado o efectivo;',
            'la tarifa de servicio de MEC por el uso de la Plataforma;',
            'la tarifa de procesamiento de pago cobrada por el procesador externo;',
            'los impuestos aplicables;',
            'el diferencial cambiario entre USD y otras modalidades de moneda cuando aplique;',
            'en Casillero Tienda, la Tarifa de Servicio de Compra cobrada por MEC y los costos de envío que la tienda externa cobre al Usuario.',
          ],
        },
        {
          t: 'p',
          text: 'MEC cobra únicamente la tarifa de servicio de MEC, la Tarifa de Servicio de Compra (Casillero Tienda), y el diferencial cambiario cuando aplique. Los demás componentes son cobrados por o transferidos a las Agencias, Comerciantes, procesadores y autoridades correspondientes.',
        },
        { t: 'h3', text: '8.2 Tipos de cambio' },
        {
          t: 'p',
          text: 'Los tipos de cambio entre USD y otras modalidades de moneda fluctúan y son determinados por MEC en función de condiciones del mercado, costos operacionales, y regulación aplicable. El tipo de cambio aplicable a una transacción es el **mostrado en la Aplicación al momento de la confirmación** y no se ajusta retroactivamente por movimientos posteriores del mercado.',
        },
        { t: 'h3', text: '8.3 Procesamiento de pagos' },
        {
          t: 'p',
          text: 'Los pagos se procesan a través de un proveedor externo autorizado. Al proporcionar información de pago, usted autoriza a MEC y a su procesador a cargar el monto total mostrado a su método de pago. La información de pago se procesa conforme a los estándares aplicables de la industria.',
        },
        { t: 'h3', text: '8.4 Cobros rechazados y disputas' },
        {
          t: 'p',
          text: 'Si el cobro es rechazado, revertido o disputado sin causa válida, MEC podrá suspender la transacción y la cuenta, exigir pago por otro método, y cobrar tarifas razonables. Las disputas de cargo (chargebacks) sin fundamento pueden resultar en suspensión permanente y acciones legales de cobro.',
        },
      ],
    },
    {
      id: 'seccion-9',
      number: '9',
      title: 'Casillero — Envíos y Tienda',
      blocks: [
        {
          t: 'p',
          text: 'Casillero agrupa dos servicios complementarios que le permiten hacer llegar a Cuba mercancía originada en los Estados Unidos por vías distintas. La disponibilidad de cada servicio depende de la Agencia asociada que usted seleccione.',
        },
        { t: 'h3', text: '9.1 Casillero Envíos' },
        {
          t: 'p',
          text: 'Usted envía por su propia cuenta un paquete a la dirección receptora de la Agencia en EE. UU. y notifica el envío en la Aplicación con el nombre del transportista y el número de seguimiento. Cuando el paquete llega, la Agencia lo recibe, lo consolida y lo despacha a Cuba conforme a estos Términos.',
        },
        {
          t: 'p',
          text: 'Usted es responsable de: (a) contratar y pagar directamente al transportista externo; (b) declarar con exactitud el contenido, peso y valor del paquete; (c) no enviar artículos prohibidos. MEC no es parte del contrato de transporte entre usted y el transportista externo, y no asume responsabilidad por pérdidas, daños o retrasos ocurridos antes de que la Agencia reciba el paquete.',
        },
        { t: 'h3', text: '9.2 Casillero Tienda — su autorización expresa' },
        {
          t: 'p',
          text: 'Al iniciar una compra bajo Casillero Tienda, usted autoriza expresamente a MEC — o a la Agencia asociada que usted seleccione, según la configuración que la Agencia haya elegido — a:',
        },
        {
          t: 'ol',
          items: [
            'actuar como su **mandatario** para ejecutar la compra en la tienda externa (por ejemplo, SHEIN, Amazon, Walmart u otras habilitadas) conforme a sus instrucciones;',
            'utilizar el método de pago registrado en su cuenta para ejecutar la compra;',
            'dirigir el envío de la compra a la dirección receptora de la Agencia para su posterior despacho a Cuba.',
          ],
        },
        {
          t: 'p',
          text: '**Usted es el comprador de derecho ante la tienda externa.** MEC no es vendedor ni revendedor de los bienes; únicamente ejecuta su instrucción de compra a nombre suyo. La relación contractual respecto de los bienes se establece entre usted y la tienda externa, sujeta a los términos y políticas de dicha tienda.',
        },
        {
          t: 'p',
          text: 'MEC cobra una **Tarifa de Servicio de Compra** por cada compra asistida, adicional al costo de los bienes y a cualquier costo de envío que la tienda externa cobre. El monto vigente se publica en la Aplicación y se le muestra antes de su confirmación.',
        },
        { t: 'h3', text: '9.3 Venta final — sin devoluciones ni reembolsos' },
        {
          t: 'p',
          text: '**Toda compra bajo Casillero Tienda es una operación final.** Usted reconoce y acepta expresamente que:',
        },
        {
          t: 'ul',
          items: [
            '**MEC no procesa devoluciones ni reembolsos** del costo de los bienes, del costo de envío cobrado por la tienda externa, ni de la Tarifa de Servicio de Compra, una vez ejecutada la compra;',
            'La Agencia no está obligada a procesar devoluciones ni a aceptar retornos de bienes adquiridos mediante Casillero Tienda;',
            '**Usted asume la totalidad del riesgo** sobre la mercancía, incluyendo defectos de fabricación, daños ocurridos durante el transporte, no conformidad con sus expectativas, errores de descripción de la tienda externa, retrasos, y pérdida antes de la recepción por la Agencia;',
            'Cualquier reclamación relativa a la mercancía deberá dirigirla directamente a la tienda externa conforme a las políticas de dicha tienda.',
          ],
        },
        {
          t: 'p',
          text: 'Esta condición se le presentará en una pantalla de confirmación previa a cada compra bajo Casillero Tienda, y usted la aceptará expresamente cada vez.',
        },
        { t: 'h3', text: '9.4 Artículos prohibidos y restricciones' },
        {
          t: 'p',
          text: 'Las restricciones y prohibiciones de la Sección 7 y de nuestra Política de Artículos Prohibidos aplican plenamente a Casillero Envíos y a Casillero Tienda. MEC podrá restringir en cualquier momento las tiendas externas, categorías de producto y transportistas externos que sean elegibles para estos servicios.',
        },
      ],
    },
    {
      id: 'seccion-10',
      number: '10',
      title: 'Cancelaciones, reembolsos y entrega',
      blocks: [
        { t: 'h3', text: '10.1 Cancelación' },
        {
          t: 'p',
          text: 'Puede solicitar la cancelación de un envío, pedido o Casillero Envío **antes de su procesamiento operacional**. Después del procesamiento, la Agencia o el Comerciante evalúa la viabilidad caso por caso. Las compras bajo Casillero Tienda no son cancelables ni reembolsables una vez ejecutadas, conforme a la Sección 9.3.',
        },
        { t: 'h3', text: '10.2 Reembolso — componentes reembolsables y no reembolsables' },
        {
          t: 'p',
          text: 'Cuando un reembolso sea procedente, se reembolsará el componente correspondiente al costo del producto, flete y arancel efectivamente no incurridos. No son reembolsables, salvo que la ley lo exija: la tarifa de servicio de MEC, la tarifa de procesamiento de pago, las comisiones de las redes de tarjetas, los costos ya incurridos frente a Agencias o transportistas, el diferencial cambiario aplicado, y la Tarifa de Servicio de Compra (Casillero Tienda).',
        },
        {
          t: 'p',
          text: 'Los reembolsos procedentes se procesan al método de pago original dentro de un plazo razonable (típicamente 5–30 días hábiles), sujeto a los plazos del procesador de pago.',
        },
        { t: 'h3', text: '10.3 Plazos de entrega' },
        {
          t: 'p',
          text: 'Los tiempos de entrega mostrados son **estimaciones de buena fe** de la Agencia o el Comerciante, no garantías. Los tiempos efectivos dependen de la aduana cubana, condiciones de transporte y bancarias, la tienda externa cuando aplique, y otros factores fuera del control de MEC, la Agencia, o el Comerciante.',
        },
        { t: 'h3', text: '10.4 Entrega, comprobantes y transferencia del riesgo' },
        {
          t: 'p',
          text: 'Cuando el paquete o el producto se entrega al destinatario, el riesgo se transfiere al destinatario. En ausencia razonable del destinatario en el momento de la entrega, la Agencia o el Comerciante podrá entregar a un adulto identificable en la misma dirección o a una dirección alternativa razonable, conforme a sus prácticas operativas.',
        },
        {
          t: 'p',
          text: 'Al confirmar una transacción, usted **autoriza a la Agencia o al Comerciante a recolectar** los siguientes elementos como comprobante de entrega, cuando aplique: firma del destinatario, fotografía del paquete o del producto entregado, número del carné de identidad del destinatario, ubicación GPS del momento de entrega, y código de verificación de un solo uso.',
        },
        {
          t: 'p',
          text: 'El destinatario debe **inspeccionar el contenido antes de firmar**. Una vez firmado el comprobante, las reclamaciones por faltantes o daños visibles se consideran renunciadas, salvo cuando la ley aplicable disponga lo contrario.',
        },
        { t: 'h3', text: '10.5 Aranceles cubanos' },
        {
          t: 'p',
          text: 'La aduana cubana determina los aranceles aplicables. Se le mostrará una **estimación** antes de la confirmación; el arancel efectivo podrá ser superior o inferior. Las diferencias correrán por su cuenta si son positivas, y se reembolsarán netas de tarifas no reembolsables si son negativas.',
        },
      ],
    },
    {
      id: 'seccion-11',
      number: '11',
      title: 'Privacidad',
      blocks: [
        {
          t: 'p',
          text: 'El tratamiento de su información personal y la del destinatario se rige por la Política de Privacidad de Mi Envío Cuba, incorporada por referencia a estos Términos. La Política de Privacidad describe, entre otras cosas: (a) qué información recopila MEC como operador de la Plataforma; (b) qué información se comparte con Agencias, Comerciantes, tiendas externas y transportistas para prestar el servicio subyacente; y (c) sus derechos como consumidor.',
        },
        {
          t: 'p',
          text: 'MEC puede compartir información con autoridades competentes cuando la ley aplicable lo requiera.',
        },
      ],
    },
    {
      id: 'seccion-12',
      number: '12',
      title: 'Propiedad de la Aplicación',
      blocks: [
        {
          t: 'p',
          text: 'La Aplicación, su código, su diseño, sus marcas (“Mi Envío Cuba”, “Mi Dashboard”, “Mi Admin”, “Mi Restaurante”, “Mi Cargo” y la familia “Mi __”), y todo el contenido proporcionado por MEC son propiedad de MEC o de sus licenciantes. MEC le concede una **licencia personal, no exclusiva, no transferible y revocable** para usar la Aplicación conforme a estos Términos.',
        },
        {
          t: 'p',
          text: 'Cualquier contenido que usted proporcione (notas, fotos, valoraciones, comentarios) puede ser usado por MEC para prestar y mejorar los Servicios. Usted otorga a MEC una licencia mundial, gratuita y no exclusiva con ese propósito, y declara que tiene derecho a otorgarla.',
        },
      ],
    },
    {
      id: 'seccion-13',
      number: '13',
      title: 'Limitación de responsabilidad',
      blocks: [
        {
          t: 'p',
          text: 'La Aplicación y los servicios de plataforma se proveen **“tal cual” y “según disponibilidad”**, sin garantías expresas o implícitas, en la máxima medida permitida por la ley.',
        },
        {
          t: 'p',
          text: 'En la máxima medida permitida por la ley, MEC no será responsable por daños indirectos, incidentales, especiales, consecuenciales ni punitivos, incluyendo lucro cesante o pérdida de datos.',
        },
        { t: 'h3', text: '13.1 MEC no responde por Agencias, Comerciantes y terceros' },
        {
          t: 'p',
          text: '**MEC no es responsable por los actos, omisiones, calidad del servicio, retrasos, pérdidas, daños, ni incumplimientos** de las Agencias, los Comerciantes, los transportistas externos, las tiendas externas, ni de ningún otro tercero que provee servicios subyacentes a través de la Plataforma. Las reclamaciones relacionadas con la ejecución del servicio subyacente se dirigen principalmente al prestador correspondiente (Agencia, Comerciante o tienda externa); MEC facilitará razonablemente la comunicación y pondrá a disposición los registros de la plataforma conforme a la Sección 3.4.',
        },
        { t: 'h3', text: '13.2 Tope de responsabilidad' },
        {
          t: 'p',
          text: 'La responsabilidad total agregada de MEC frente a usted no excederá la mayor de: (a) el monto efectivamente pagado por usted a MEC en los doce (12) meses anteriores al hecho que dio origen a la reclamación; o (b) US$ 100. Este tope no aplica a los reembolsos procedentes conforme a la Sección 10, ni a la responsabilidad por dolo o culpa grave, ni a derechos no renunciables del consumidor.',
        },
        { t: 'h3', text: '13.3 Riesgos del corredor' },
        {
          t: 'p',
          text: 'Usted reconoce los riesgos específicos del corredor EE. UU. — Cuba (cambios en sanciones, suspensión de bancos o procesadores, restricciones aduanales cubanas, fluctuaciones cambiarias, fuerza mayor). MEC no responde por los efectos de estos riesgos.',
        },
      ],
    },
    {
      id: 'seccion-14',
      number: '14',
      title: 'Indemnización',
      blocks: [
        {
          t: 'p',
          text: 'Usted se obliga a **indemnizar, defender y mantener indemne** a MEC, a sus afiliadas, a sus directores, empleados, contratistas, Agencias y Comerciantes asociados, frente a toda reclamación, demanda, pérdida, daño, costo y gasto razonable (incluyendo honorarios razonables de abogado) derivados de o relacionados con:',
        },
        {
          t: 'ol',
          items: [
            'su incumplimiento de estos Términos;',
            'su violación de la ley aplicable, incluyendo las Regulaciones de Activos Cubanos (31 C.F.R. Parte 515), las Regulaciones de Administración de Exportaciones (EAR), y las leyes de transmisión de dinero;',
            'la falsedad o inexactitud de las declaraciones de la Sección 5;',
            'el contenido de los paquetes o pedidos que usted origine, o de las Compras Asistidas que usted autorice;',
            'la información que usted proporcione sobre el destinatario, incluyendo su elegibilidad y la exactitud de sus datos;',
            'cualquier disputa entre usted y un tercero (incluyendo el destinatario, la Agencia, el Comerciante, un transportista externo o una tienda externa) relacionada con los servicios subyacentes.',
          ],
        },
        {
          t: 'p',
          text: 'MEC podrá, a su elección y a su costo, asumir el control exclusivo de la defensa de cualquier reclamación indemnizable. Usted cooperará razonablemente en dicha defensa.',
        },
      ],
    },
    {
      id: 'seccion-15',
      number: '15',
      title: 'Suspensión y terminación',
      blocks: [
        {
          t: 'p',
          text: 'MEC puede suspender o cerrar su cuenta **inmediatamente** si: (a) usted incumple estos Términos o la ley aplicable; (b) sospechamos razonablemente fraude, lavado, evasión de sanciones o uso indebido; (c) usted o un destinatario aparece en una lista de sanciones; (d) una autoridad competente lo requiere; o (e) la continuación del servicio expondría a MEC a un riesgo regulatorio o reputacional inaceptable.',
        },
        {
          t: 'p',
          text: 'Usted puede cerrar su cuenta en cualquier momento, sujeto a la liquidación de transacciones pendientes.',
        },
        {
          t: 'p',
          text: 'Sobreviven a la terminación las Secciones 5, 7 (en la parte de cooperación con investigaciones), 8 (por montos devengados), 11, 12, 13, 14, 16 y 17, y cualquier otra disposición que por su naturaleza deba sobrevivir.',
        },
      ],
    },
    {
      id: 'seccion-16',
      number: '16',
      title: 'Disputas',
      blocks: [
        {
          t: 'p',
          text: 'Antes de cualquier procedimiento formal, las partes negociarán de buena fe durante al menos treinta (30) días tras notificación escrita.',
        },
        {
          t: 'p',
          text: 'Toda disputa que no se resuelva por negociación se resolverá mediante **arbitraje individual obligatorio** ante la American Arbitration Association (AAA) bajo sus reglas comerciales, en el Condado de Miami-Dade, Florida, en inglés o español a su elección.',
        },
        {
          t: 'p',
          text: 'Las partes **renuncian a demandas colectivas y al juicio por jurado**, en la medida permitida por la ley.',
        },
        {
          t: 'p',
          text: 'Usted puede optar por **excluirse del arbitraje** enviándonos notificación escrita dentro de los treinta (30) días siguientes a su aceptación inicial de estos Términos.',
        },
        {
          t: 'p',
          text: 'Cuando el arbitraje no aplique, la jurisdicción exclusiva serán los tribunales estatales y federales de Miami-Dade County, Florida.',
        },
        {
          t: 'p',
          text: 'Ninguna disposición de esta Sección impide a cualquier parte solicitar medidas cautelares ante un tribunal competente para proteger derechos de propiedad intelectual o información confidencial, ni acudir a un tribunal de menores cuantías cuando aplique.',
        },
        {
          t: 'p',
          text: 'Estos Términos se rigen por las leyes del Estado de Florida y por la ley federal de EE. UU. cuando aplique.',
        },
      ],
    },
    {
      id: 'seccion-17',
      number: '17',
      title: 'Disposiciones generales',
      blocks: [
        { t: 'h3', text: '17.1 Modificaciones' },
        {
          t: 'p',
          text: 'MEC puede modificar estos Términos. Las modificaciones materiales se notificarán con al menos treinta (30) días de anticipación dentro de la Aplicación o por correo electrónico. El uso continuado tras la entrada en vigor constituye aceptación.',
        },
        { t: 'h3', text: '17.2 Comunicaciones' },
        {
          t: 'p',
          text: 'MEC le enviará avisos por correo electrónico, dentro de la Aplicación, o por SMS. Algunos avisos son obligatorios bajo la regulación aplicable y no pueden deshabilitarse.',
        },
        { t: 'h3', text: '17.3 Cesión' },
        {
          t: 'p',
          text: 'Usted no puede ceder sus derechos u obligaciones bajo estos Términos sin el consentimiento previo y escrito de MEC. MEC podrá ceder libremente sus derechos y obligaciones a una afiliada, o en el marco de una fusión, adquisición, reorganización o venta sustancial de activos.',
        },
        { t: 'h3', text: '17.4 Acuerdo íntegro' },
        {
          t: 'p',
          text: 'Estos Términos, junto con la Política de Privacidad y cualquier política publicada dentro de la Aplicación (incluyendo la Política de Artículos Prohibidos, las Guías de la Comunidad, la Política DMCA, la Política de Cookies y el Aviso de Derechos de Privacidad Estatales), constituyen el acuerdo íntegro entre usted y MEC respecto de los Servicios, y reemplazan toda comunicación, promesa, o entendimiento previo, ya sea verbal o escrito.',
        },
        { t: 'h3', text: '17.5 Contratistas independientes' },
        {
          t: 'p',
          text: 'Las partes son contratistas independientes. Estos Términos no crean relación de empleo, mandato, sociedad, empresa conjunta ni relación fiduciaria entre las partes. Ninguna disposición de estos Términos concede a las Agencias, Comerciantes u otros terceros derecho de terceros beneficiarios frente a MEC ni frente a usted, salvo cuando se indique expresamente.',
        },
        { t: 'h3', text: '17.6 Fuerza mayor' },
        {
          t: 'p',
          text: 'En caso de fuerza mayor (cambios en sanciones, “de-risking” bancario, eventos aduanales o regulatorios cubanos, pandemias, paros, cortes de servicios), ninguna parte será responsable de incumplimientos o demoras.',
        },
        { t: 'h3', text: '17.7 Divisibilidad' },
        {
          t: 'p',
          text: 'Si alguna disposición de estos Términos es declarada inválida o inejecutable, las demás disposiciones permanecerán en pleno vigor, y la disposición afectada se reformulará al mínimo necesario para que sea ejecutable.',
        },
        { t: 'h3', text: '17.8 Renuncia' },
        {
          t: 'p',
          text: 'La omisión de MEC de hacer valer cualquier derecho no constituye renuncia a tal derecho.',
        },
        { t: 'h3', text: '17.9 Idioma' },
        {
          t: 'p',
          text: 'Estos Términos se publican originalmente en español. Si MEC publica una versión en inglés, el texto en español prevalecerá ante divergencia, salvo que la ley aplicable disponga lo contrario.',
        },
      ],
    },
    {
      id: 'seccion-18',
      number: '18',
      title: 'Contacto',
      blocks: [
        {
          t: 'ul',
          items: [
            '**Correo:** support@mienviocuba.com',
            '**Teléfono:** +1 (786) 519-1709',
            '**Entidad:** MEC LLC, sociedad de responsabilidad limitada del estado de Florida, Estados Unidos.',
          ],
        },
      ],
    },
  ],
};
